// 날짜 구분선 공용 유틸 — ChatWindow 메시지 구분선과 AttachmentDrawer 날짜 그룹핑이 공유

// Intl 포맷터는 생성 비용이 커서 모듈 레벨 싱글턴으로 재사용 (매 렌더 × 항목 수만큼 생성 방지)
const DATE_LABEL_FORMATTER = new Intl.DateTimeFormat('ko-KR', {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
  weekday: 'long',
});

/** 날짜 구분선 라벨: '오늘' / '어제' / '2026년 8월 13일 목요일' */
export const formatDateLabel = (dateStr: string): string => {
  const date = new Date(dateStr);
  const today = new Date();
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);

  const isSameDay = (a: Date, b: Date) =>
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate();

  if (isSameDay(date, today)) return '오늘';
  if (isSameDay(date, yesterday)) return '어제';

  return DATE_LABEL_FORMATTER.format(date);
};

/** 두 timestamp가 다른 날짜인지 (로컬 기준) */
export const isDifferentDate = (date1: string, date2: string): boolean => {
  const d1 = new Date(date1);
  const d2 = new Date(date2);
  return d1.getFullYear() !== d2.getFullYear() ||
    d1.getMonth() !== d2.getMonth() ||
    d1.getDate() !== d2.getDate();
};
